import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-secondary-900" role="contentinfo">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 py-16">
          <div className="flex flex-col gap-5">
            <div className="flex items-center gap-2">
              <span className="text-2xl font-black font-heading tracking-tight text-primary-500">91</span>
              <span className="text-xl font-bold text-background-50">免费</span>
            </div>
            <p className="text-secondary-200 text-sm leading-relaxed">
              91免费是领先的娱乐八卦资讯平台，覆盖明星八卦、网红爆料、黑料吃瓜等热门内容，每日实时更新，让你永远站在吃瓜第一线。
            </p>
            <div className="flex items-center gap-3 mt-2">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div className="flex flex-col gap-5">
            <h3 className="text-background-50/70 text-xs font-semibold uppercase tracking-wider">热门分类</h3>
            <div className="flex flex-col gap-3">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-secondary-200 hover:text-background-50 text-sm transition-colors duration-200 cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-5">
            <h3 className="text-background-50/70 text-xs font-semibold uppercase tracking-wider">快速链接</h3>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-secondary-200 hover:text-background-50 text-sm transition-colors duration-200 cursor-pointer">首页</Link>
              <Link to="/about" className="text-secondary-200 hover:text-background-50 text-sm transition-colors duration-200 cursor-pointer">关于我们</Link>
              <Link to="/category/scandal" className="text-secondary-200 hover:text-background-50 text-sm transition-colors duration-200 cursor-pointer">黑料吃瓜</Link>
              <Link to="/category/daily-update" className="text-secondary-200 hover:text-background-50 text-sm transition-colors duration-200 cursor-pointer">每日更新</Link>
              <a href="#" className="text-secondary-200 hover:text-background-50 text-sm transition-colors duration-200">隐私政策</a>
              <a href="#" className="text-secondary-200 hover:text-background-50 text-sm transition-colors duration-200">用户协议</a>
            </div>
          </div>

          <div className="flex flex-col gap-5">
            <h3 className="text-background-50/70 text-xs font-semibold uppercase tracking-wider">联系我们</h3>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-mail-line text-secondary-300 text-sm"></i>
                </span>
                <span className="text-secondary-200 text-sm">contact@91free.com</span>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-customer-service-line text-secondary-300 text-sm"></i>
                </span>
                <span className="text-secondary-200 text-sm">400-888-9191</span>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-secondary-300 text-sm"></i>
                </span>
                <span className="text-secondary-200 text-sm">北京市朝阳区建国路88号SOHO现代城A座</span>
              </div>
            </div>

            <div className="mt-2">
              <form className="flex items-end gap-0">
                <div className="flex-1 border-b border-secondary-600 focus-within:border-background-50 transition-colors duration-200">
                  <input
                    type="email"
                    name="email"
                    placeholder="输入邮箱订阅更新"
                    className="w-full bg-transparent text-background-50 text-sm py-2 outline-none placeholder:text-secondary-400"
                  />
                </div>
                <button
                  type="submit"
                  className="w-10 h-10 flex items-center justify-center text-background-50 hover:text-primary-400 transition-colors duration-200 cursor-pointer flex-shrink-0"
                  aria-label="订阅"
                >
                  <i className="ri-send-plane-fill text-sm"></i>
                </button>
              </form>
              <p className="text-secondary-400 text-xs mt-2">
                订阅即表示同意我们的
                <a href="#" className="text-primary-400 hover:text-primary-300 cursor-pointer">隐私政策</a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-800/50">
        <div className="w-full px-4 md:px-8 py-10">
          <div className="text-center">
            <div className="text-6xl md:text-8xl lg:text-9xl font-black font-heading tracking-tighter text-secondary-800/60 leading-none select-none">
              91FREE
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-800/50">
        <div className="w-full px-4 md:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-secondary-400 text-xs">
            &copy; {currentYear} 91免费 版权所有 | 京ICP备2024000000号-1
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-secondary-400 hover:text-background-50 text-xs transition-colors duration-200">隐私政策</a>
            <a href="#" className="text-secondary-400 hover:text-background-50 text-xs transition-colors duration-200">服务条款</a>
            <a href="#" className="text-secondary-400 hover:text-background-50 text-xs transition-colors duration-200">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}